import { connect } from 'react-redux'
import FPSMeter from '../components/FPSMeter'
import { setMeanFPS } from '../actions'

const mapStateToProps = state => ({
    enabled: state.getIn(['stats', 'enableFPSMeter']),
    interval: state.getIn(['stats', 'fpsMeterInterval']),
})

const mapDispatchToProps = (dispatch, { interval = 3000 }) => ({
    onInterval: meanFPS => {
        dispatch(setMeanFPS(meanFPS, interval))
    },
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FPSMeter)
